import React from 'react';

import { use100vh } from 'nike-ui/src/components/forms/Vh100Context';
import i18n from '@i18n';

function OnbLoader() {
    const minHeight = use100vh();

    return (
        <div style={{ minHeight: minHeight }}>
            <div className="onbLoader">{i18n('commons.term.loading')}</div>
        </div>
    );
}

export default OnbLoader;
